import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5ca97009"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "SearchContent"
};
var _hoisted_2 = {
  class: "content-box"
};
var _hoisted_3 = {
  class: "topTitle"
};
var _hoisted_4 = {
  class: "keyword"
};
var _hoisted_5 = {
  class: "key-count"
};
var _hoisted_6 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ListDetailNav = _resolveComponent("ListDetailNav");

  var _component_Pagination = _resolveComponent("Pagination");

  var _component_Loading = _resolveComponent("Loading");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 标题 "), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.route.params.id), 1
  /* TEXT */
  ), _createElementVNode("span", _hoisted_5, "找到 " + _toDisplayString(_ctx.searchTypeInfo.total || 0) + " " + _toDisplayString(_ctx.text), 1
  /* TEXT */
  )]), _createCommentVNode(" 导航 "), _createVNode(_component_ListDetailNav, {
    navList: _ctx.navList.map(function (item) {
      return item.title;
    }),
    navMarginR: "30px",
    onTitleClick: _ctx.titleClick
  }, null, 8
  /* PROPS */
  , ["navList", "onTitleClick"]), Object.keys(_ctx.searchTypeInfo).length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createCommentVNode("动态组件 5个页面 "), (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentId), {
    class: "item",
    musicList: _ctx.searchTypeInfo.songs,
    artistList: _ctx.searchTypeInfo.artists,
    albumList: _ctx.searchTypeInfo.albums,
    videoList: _ctx.searchTypeInfo.videos,
    sheetList: _ctx.searchTypeInfo.playlists,
    inputValue: _ctx.route.params.id
  }, null, 8
  /* PROPS */
  , ["musicList", "artistList", "albumList", "videoList", "sheetList", "inputValue"])), _createCommentVNode(" 分页器 "), _ctx.searchResInfo.limit < _ctx.searchTypeInfo.total ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 0,
    total: _ctx.searchTypeInfo.total,
    pageInfo: _ctx.searchResInfo,
    curtPage: _ctx.curtPage,
    onChangeCurrent: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["total", "pageInfo", "curtPage", "onChangeCurrent"])) : _createCommentVNode("v-if", true)])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }))])]);
}